<template>
  <div class="home" style="width:100%;">
    <v-row v-if="!loader">
      <v-col cols="3">
        <h2>Overview</h2>
        <v-card outlined class="mb-3">
          <v-card-title>Bulk Actions</v-card-title>
          <v-card-text class="d-flex flex-row">
            <!-- <v-btn @click="openBulkPrintDialog()" class="mr-2" fab color="purple" style="color: white;"><v-icon>mdi-printer</v-icon></v-btn> -->
            <v-btn @click="openDirectBulkPrintDialog()" class="mr-2" fab color="info" style="color: white;"><v-icon>mdi-printer</v-icon></v-btn>
            <v-btn @click="openBulkOutDialog()" class="mr-2" fab color="warning"><v-icon>mdi-home-export-outline</v-icon></v-btn>
            <v-btn @click="openBulkInDialog()" class="mr-2" fab color="info"><v-icon>mdi-home-import-outline</v-icon></v-btn>
            <v-btn @click="openBulkCustomerDialog()" class="mr-2" fab color="error"><v-icon>mdi-check</v-icon></v-btn>
          </v-card-text>
        </v-card>
        <v-card outlined class="mb-3">
        </v-card>
        <v-card outlined>
          <span class="d-flex flex-row align-center">
            <v-card-title>Filters</v-card-title>
            <v-btn x-small @click="clearFilters" class="mr-2" fab color="error"><v-icon>mdi-refresh</v-icon></v-btn>
          </span>
          <v-chip-group class="mx-4" row>
            <v-chip v-if="this.filters.tailorId" dense>Tailor</v-chip>
            <v-chip v-if="this.filters.jobId" dense>Job</v-chip> 
            <v-chip v-if="this.filters.eventType" dense>Event Type</v-chip>
            <v-chip v-if="this.filters.gender" dense>Gender</v-chip>
          </v-chip-group>
          <v-card-text>
            <v-autocomplete
              :items="tailors"
              :item-text="x => x.name"
              item-value="id"
              label="Filter by Tailor"
              dense
              clearable
              outlined
              v-model="filters.tailorId"
              @change="filterByTailor()"
            />
            <v-autocomplete
              :items="events"
              :item-text="x => x.name"
              item-value="job.id"
              label="Filter by Job"
              dense
              clearable
              outlined
              v-model="filters.jobId"
              @change="filterByJob()"
            />
            <v-autocomplete
              :items="colors"
              label="Filter by Event Type"
              dense
              clearable
              outlined
              v-model="filters.eventType"
              @change="filterByEventType()"
            />
            <v-autocomplete
              :items="genders"
              item-text="name"
              item-value="value"
              label="Filter by Gender"
              dense
              clearable
              outlined
              v-model="filters.gender"
              @change="filterByGender()"
            />
            <v-autocomplete
              :items="types"
              item-text="name"
              item-value="value"
              label="Filter by Type"
              dense
              clearable
              outlined
              v-model="filters.type"
              @change="filterByType()"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="9">
        <div class="d-flex flex-row">
          <h2>Job Schedule</h2>
          <v-btn x-small @click="openCreateJobDialog" class="mx-2" fab color="success"><v-icon>mdi-plus</v-icon></v-btn>
        </div>
        <span class="d-flex flex-row align-center">
          <span style="width: 12px; height: 12px; border-radius: 12px; background-color: #FF9800;"></span><span class="ml-1">Date Out ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.job.dateOut===x.start).length|| 0}})</span>
          <span class="ml-3" style="width: 12px; height: 12px; border-radius: 12px; background-color: #2196F3;"></span><span class="ml-1">Date In ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.job.dateIn===x.start).length|| 0}})</span>
          <span class="ml-3" style="width: 12px; height: 12px; border-radius: 12px; background-color: #F44336;"></span><span class="ml-1">Date Due ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.job.dateToHand===x.start).length|| 0}})</span>
          <span class="ml-3" style="font-size: 11px;">✅ Event Done</span>
          <span class="ml-3" style="font-size: 11px;" v-for="(loc, i) of getLocations" :key="i">{{lookupLocationIcon(loc.id)}} {{lookupLocationIcon(loc.id)!==loc.name?loc.name:''}}</span>
          <span class="ml-3" style="font-size: 11px;">👗 Formal ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.job.type===1).length|| 0}})</span>
          <span class="ml-3" style="font-size: 11px;">💍 Bridal ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.job.type===2).length|| 0}})</span>
          <span class="ml-3" style="font-size: 11px;"> Male ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.job.gender===1).length|| 0}})</span>
          <span class="ml-3" style="font-size: 11px;"> Female ({{eventsToDisplay.filter(x => x.start>=viewStart && x.start &lt;= viewEnd && x.job.gender===2).length|| 0}})</span>
        </span>
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn outlined class="mr-4" @click="setTodayMonth" >Refresh</v-btn>
            <v-btn outlined class="mr-4" @click="setToday" >View Today</v-btn>
            <v-btn fab text small @click="prev">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-btn fab text small @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-progress-circular
                indeterminate
                color="green"
                v-if="calenderLoader"
                style="margin-left: 10px;"
            />
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="eventsToDisplay"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          />
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card
              min-width="350px"
              flat
            >
              <v-toolbar
                :color="selectedEvent.color"
                dark
              >
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <authorizer 
                  v-if="selectedEvent.job && selectedEvent.job.status>-1" 
                  v-bind:fabicon="'mdi-printer'" 
                  v-bind:color="'purple'" 
                  v-on:response="attemptPrint($event)"/>
                <v-btn icon>
                  <v-icon @click="goToJob(selectedEvent.job.id)">mdi-chevron-right</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="selectedEvent.job">
                <span class="d-flex flex-column">
                  <h3>Current Status: {{parseJobStatus(selectedEvent.job.status)}}</h3>
                  <b>Maska: {{selectedEvent.job.metadata.isMaska}}</b>
                  <b>Customer: {{selectedEvent.job.Item.Customer.firstName}} {{selectedEvent.job.Item.Customer.lastName}} | {{selectedEvent.job.Item.Customer.phone}}</b >
                  <b>Gender: {{selectedEvent.job.gender}}</b>
                  <b>Job Type: {{parseJobType(selectedEvent.job.type)}}</b>
                  <b>Tailor: {{(selectedEvent.job.Tailor?selectedEvent.job.Tailor.name:'')}} | {{(selectedEvent.job.Tailor?selectedEvent.job.Tailor.phone:'')}}</b>
                  <b v-if="getPerms.permissions.job.viewRevenue">Tailor Cost: {{selectedEvent.job.tailorCost}}</b>
                  <b>Customer Price: {{selectedEvent.job.totalCost}}</b>
                  <b v-if="getPerms.permissions.job.viewRevenue">Revenue: {{selectedEvent.job.totalCost-selectedEvent.job.tailorCost}}</b>
                  <b>Item: {{selectedEvent.job.Item.Asset.styleNo}} ({{selectedEvent.job.Item.colour}})</b>
                  <b>Date Out: {{momentDateFormat(selectedEvent.job.dateOut)}}</b>
                  <b>Date In: {{momentDateFormat(selectedEvent.job.dateIn)}}</b>
                  <b>Date Due: {{momentDateFormat(selectedEvent.job.dateToHand)}}</b>
                  <b>Event: </b>
                  <b>Transaction ID: {{selectedEvent.job.transactionId}}</b>
                </span>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  color="secondary"
                  @click="selectedOpen = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
      <v-col class="col-md-2">
      </v-col>
    </v-row>

    <v-dialog scrollable v-model="createJobDialog" max-width="800">
      <v-card>
        <v-card-title>Create New Job {{appointmentData.id?`for Appointment #${appointmentData.id}`:''}}</v-card-title>
         <v-card-text class="pa-5">
          <v-form v-model="validCreate" class="d-flex flex-column justify-start">
<!--            <v-checkbox v-model="formData.metadata.isMaska" label="Maska"/>-->
            <span>
              <v-radio-group v-model="formData.branchId" row>
                <v-radio v-for="(loc, i) in getLocations" :key="i" :label="loc.name" :value="loc.id"/>
              </v-radio-group>
            </span>
            <span class="d-flex flex-row">
              <v-autocomplete
                  :items="customers"
                  :item-text="x => x.fullName + (x.phone?' | '+x.phone:'') + (x.email?' | '+x.email:'')"
                  item-value="id"
                  label="Customer"
                  dense
                  outlined
                  clearable
                  :disabled="formData.appointmentId!=null"
                  @change="createdCustomerChanged"
                  :rules="rules.required"
                  v-model="formData.Item.customerId"
              />
              <v-btn class="ml-1 mr-2" @click="openCreateCustomerDialog('create')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
              <v-autocomplete
                  :items="tailors"
                  item-text="name"
                  item-value="id"
                  label="Tailor"
                  outlined
                  dense
                  clearable
                  v-model="formData.tailorId"
                  class="mr-2"
              />
            </span>
            <span class="d-flex flex-row">
              <v-select
                  class=""
                  :items="jobTypes"
                  item-text="name"
                  item-value="id"
                  label="Type"
                  outlined
                  dense
                  v-model="formData.type"
              />
              <v-select
                  class="ml-2"
                  :items="genders"
                  item-text="name"
                  item-value="id"
                  label="Gender"
                  outlined
                  dense
                  v-model="formData.gender"
              />
            </span>
            <span class="d-flex flex-row">
              <v-text-field v-if="isAllowed('job', 'viewRevenue')" class="mr-2" outlined dense label="Tailor Cost" v-model="formData.tailorCost"/>
              <v-text-field class="mr-2" outlined dense label="Customer Price" v-model="formData.totalCost"/>
              <span v-if="isAllowed('job', 'viewRevenue')" style="width: 200px;">Revenue: {{formData.totalCost-formData.tailorCost||0}}</span>
            </span>
            <span class="d-flex flex-column">
              <span class="d-flex flex-row">
                <v-autocomplete
                    :items="items"
                    item-text="name"
                    return-object
                    :label="formData.Item.customerId?'Item':'Select a customer first...'"
                    outlined
                    dense
                    clearable
                    hint="Item"
                    :persistent-hint="formData.Item.customerId==null"
                    :loading="loadingItems"
                    :disabled="!formData.Item.customerId"
                    :rules="rules.required"
                    v-model="formData.Item.item"
                />
                <v-btn class="ml-1" @click="showCreateAssetDialog('create')" :disabled="!formData.Item.customerId" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                <v-text-field class="ml-2" outlined dense v-if="formData.Item && formData.Item.item && formData.Item.item.type==='asset'" label="Colour" v-model="formData.Item.item.colour"/>
              </span>
            </span>
            <span class="d-flex flex-row">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="0"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(formData.dateOut)"
                      label="Date Out"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="formData.dateOut"
                />
              </v-menu>
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="0"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(formData.dateIn)"
                      label="Date In"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="formData.dateIn"
                />
              </v-menu>
              <v-menu
                  :close-on-content-click="false"
                  :nudge-left="50"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(formData.dateToHand)"
                      label="Date Due"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="formData.dateToHand"
                />
              </v-menu>
            </span>
            <span class="d-flex flex-row ">
                <v-autocomplete
                    :items="events"
                    :item-text="x => x.name + ` (ID: ${x.id}, Customer: ${x.Customer?x.Customer.fullName:'ERROR'})`"
                    item-value="id"
                    label="Event (Optional)"
                    dense
                    clearable
                    outlined
                    v-model="formData.eventId"
                />
                <v-btn class="ml-1 mr-2" @click="showCreateEventDialog('create')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                <v-text-field class="" dense outlined label="Transaction ID" v-model="formData.transactionId"/>
              </span>
            <span>
                <v-autocomplete
                    :items="pinners"
                    :item-text="x => lookupUsername(x.id)"
                    item-value="id"
                    label="Pinned By"
                    dense
                    clearable
                    outlined
                    v-model="formData.pinnedBy"
                />
            </span>
            <span v-if="formData.gender===1">
              <span class="d-flex flex-row align-center">
                <h4>Alteration Type</h4>
              </span>
              <v-autocomplete
                  :items="alterationTypes"
                  :loading="alterationsLoading"
                  outlined
                  deletable-chips
                  dense
                  item-text="name"
                  item-value="id"
                  v-model="formData.alterationType"
                  @change="loadAlterations(true)"
              />
            </span>
            <span v-if="formData.gender===1">
              <span class="d-flex flex-row align-center">
                <h4>Current Alterations</h4>
              </span>
              <v-autocomplete
                  :items="formDataAlterations"
                  :loading="alterationsLoading"
                  :disabled="formData.alterationType===null"
                  multiple
                  chips
                  dense
                  outlined
                  deletable-chips
                  return-object
                  :item-text="(x => {return `${x.name} ($${x.price})`})"
                  v-model="formData.itemAlterations"
                  @change="calculateCustomerCostForNewUnlinkedJob"
              />
            </span>
            <span>
                <v-textarea label="Notes" v-model="formData.alterations" dense outlined/>
            </span>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateJobDialog">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreate" @click="saveJob" :loading="createJobLoading">Create</v-btn>
<!--          <v-btn color="info" @click="resetCreateJobDialog">Reset</v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createCustomerDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create Customer
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateCustomer">
            <v-text-field
                label="First Name"
                outlined
                :rules="rules.required"
                v-model="newCustomer.firstName"
                @input="existingData=null"
            />
            <v-text-field
                label="Last Name"
                outlined
                :rules="rules.required"
                v-model="newCustomer.lastName"
                @input="existingData=null"
            />
            <v-text-field
                label="Phone"
                outlined
                v-model="newCustomer.phone"
                @input="existingData=null"
            />
            <v-text-field
                label="Email"
                outlined
                v-model="newCustomer.email"
                @input="existingData=null"
            />
            <span>
              <h3>Address</h3>
              <v-text-field
                  label="Address Line 1"
                  outlined
                  v-model="newCustomer.address.line1"
                  @input="existingData=null"
              />
              <v-text-field
                  label="Address Line 2"
                  outlined
                  v-model="newCustomer.address.line2"
                  @input="existingData=null"
              />
              <v-text-field
                  label="City"
                  outlined
                  v-model="newCustomer.address.city"
                  @input="existingData=null"
              />
              <v-text-field
                  label="Notes"
                  outlined
                  v-model="newCustomer.notes"
                  @input="existingData=null"
              />
            </span>
          </v-form>
          <div v-if="existingData">
            <p class="red--text">A Customer with this phone number already exists. Are you sure you want to create another?</p>
            <h3>Or choose the existing Customer</h3>
            <v-btn color="info" @click="existingCustomerSelected">{{existingData.firstName}} {{existingData.lastName}}</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateCustomer">
            Cancel
          </v-btn>
          <v-btn color="success" v-if="!existingData" :disabled="!validCreateCustomer" @click="createCustomer(customerUsage)" :loading="customerLoading">Create</v-btn>
          <v-btn v-else color="success" :disabled="!validCreateCustomer" @click="confirmCreateCustomer(customerUsage)" :loading="customerLoading">Create New</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createAssetDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create New Asset (Default Item)
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateAsset">
            <v-text-field
                label="Style No."
                outlined
                :rules="rules.required"
                v-model="newAsset.styleNo"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateAsset">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreateAsset" @click="createAsset(assetUsage)" :loading="assetLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createEventDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create New Event
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateEvent">
            <span class="d-flex flex-row">
                <v-autocomplete
                    :items="customers"
                    :item-text="x => x.fullName + (x.phone?' | '+x.phone:'') + (x.email?' | '+x.email:'')"
                    item-value="id"
                    label="Primary Customer"
                    dense
                    outlined
                    :rules="rules.required"
                    v-model="newEvent.customerId"
                />
                <v-btn class="ml-1" @click="openCreateCustomerDialog('event')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
              </span>
            <v-text-field
                label="Name"
                outlined
                :rules="rules.required"
                v-model="newEvent.name"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateEvent">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreateEvent" @click="createEvent(eventUsage)" :loading="eventLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="this.dialogs.directBulkPrint.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.directBulkPrint.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Direct Bulk Print.</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field autofocus v-model="dialogs.directBulkPrint.values" outlined></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeDirectBulkPrintDialog()">Cancel</v-btn>
          <v-btn color="primary" text @click="handleDirectBulkPrint()">Print</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="this.dialogs.bulkPrint.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.bulkPrint.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Bulk Print.</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field autofocus v-model="dialogs.bulkPrint.values" outlined></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeBulkPrintDialog()">Cancel</v-btn>
          <authorizer 
            v-if="dialogs.bulkPrint.values" 
            :buttontext="'Bulk Print'"
            :color="'success'" 
            :authorization="this.authorizations.bulkPrint" 
            v-on:response="handleBulkPrint($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="this.dialogs.bulkOut.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.bulkOut.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Bulk Out.</h3>
        </v-card-title>
        <v-card-text>
          <v-data-table
            outlined
            :headers="dialogs.bulkOut.tableHeaders"
            :items="this.scanBus.data"
            :items-per-page="-1"
            dense
          >
            <template v-slot:item.name="{ item }">
              #{{item.job.id}} [{{item.job.Tailor.metadata.shortName}}] {{item.job.Item.Customer.firstName}} {{item.job.Item.Customer.lastName}}
            </template>
            <template v-slot:item.remove="{ item}">
              <v-btn icon><v-icon @click="removeJob(item.job.id)">mdi-close</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeBulkOutDialog()">Cancel</v-btn>
          <authorizer 
            v-if="this.dialogs.bulkOut.isOpen&&this.scanBus.data&&this.scanBus.data.length>0&&this.scanBus.data.reduce((acc,job)=>acc&&job.ok,true)" 
            :buttontext="'Send Bulk Out'"
            :color="'success'" 
            :authorization="this.authorizations.bulkOut" 
            v-on:response="handleBulkOut($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="this.dialogs.bulkIn.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.bulkIn.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Bulk In.</h3>
        </v-card-title>
        <v-card-text>
          <v-data-table
            outlined
            :headers="dialogs.bulkIn.tableHeaders"
            :items="this.scanBus.data"
            :items-per-page="-1"
            dense
          >
            <template v-slot:item.name="{ item }">
              #{{item.job.id}} [{{item.job.Tailor.metadata.shortName}}] {{item.job.Item.Customer.firstName}} {{item.job.Item.Customer.lastName}}
            </template>
            <template v-slot:item.remove="{ item}">
              <v-btn icon><v-icon @click="removeJob(item.job.id)">mdi-close</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeBulkInDialog()">Cancel</v-btn>
          <authorizer 
            v-if="this.dialogs.bulkIn.isOpen&&this.scanBus.data&&this.scanBus.data.length>0&&this.scanBus.data.reduce((acc,job)=>acc&&job.ok,true)" 
            :buttontext="'Receive Bulk In'"
            :color="'success'" 
            :authorization="this.authorizations.bulkIn" 
            v-on:response="handleBulkIn($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="this.dialogs.bulkCustomer.isOpen" width="900" persistent>
      <v-card style="overflow-y:hidden">
        <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="this.dialogs.bulkCustomer.loader"
            style="margin-top: 20px; margin-bottom: 10px;"
          ></v-progress-circular>
          <h3>Add items for Bulk Customer Collect.</h3>
        </v-card-title>
        <v-card-text>
          <v-data-table
            outlined
            :headers="dialogs.bulkCustomer.tableHeaders"
            :items="this.scanBus.data"
            :items-per-page="-1"
            dense
          >
            <template v-slot:item.name="{ item }">
              #{{item.job.id}} [{{item.job.Tailor.metadata.shortName}}] {{item.job.Item.Customer.firstName}} {{item.job.Item.Customer.lastName}}
            </template>
            <template v-slot:item.remove="{ item}">
              <v-btn icon><v-icon @click="removeJob(item.job.id)">mdi-close</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeBulkCustomerDialog()">Cancel</v-btn>
          <authorizer 
            v-if="this.dialogs.bulkCustomer.isOpen&&this.scanBus.data&&this.scanBus.data.length>0&&this.scanBus.data.reduce((acc,job)=>acc&&job.ok,true)" 
            :buttontext="'Bulk Customer Collect'"
            :color="'success'" 
            :authorization="this.authorizations.bulkCustomer" 
            v-on:response="handleBulkCustomer($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
import { mapGetters, mapMutations} from 'vuex'
import axios from 'axios';
import moment from 'moment';
import authorizer from '../components/authorizer.vue';
export default {
  name: 'Home',
  components: {
    authorizer
  },
  computed: {
    ...mapGetters(['getUsername', 'getEndpoint', 'scanBus', 'getPerms', 'isAllowed', 'lookupUsername', 'getLocations', 'lookupLocationIcon']),
  },
  data () {
    return {
      loader: true,
      calenderLoader: false,
      snackObj: {
        color: '',
        text: ''
      },
      username: '',
      password: '',
      valid: false,
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      eventsToDisplay: [],
      genders: [
        {name: "None", value: 0, id: 0},  
        {name: "Male 🤵", value: 1, id: 1},
        {name: "Female 👰", value: 2, id: 2}
      ],
      types: [{name: "Link 🔗", value: 2}, {name: "Parent Link ⭐", value: 1}, {name: 'No Link', value: 0}],
      colors: ['blue', 'orange', 'red'],
      names: ['In', 'Out', 'Handed Off'],
      jobs: [],
      tomorrowJobs: [],
      authorizations: {
        print: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'printJobTicket', key:'printJobTicket'},
        bulkPrint: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'printJobTicketBulk', key:'printJobTicketBulk'},
        bulkOut: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatusBulk', key:'modifyJobStatusBulk'},
        bulkIn: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatusBulk', key:'modifyJobStatusBulk'},
        bulkCustomer: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatusBulk', key:'modifyJobStatusBulk'},
      },
      filters:{
        tailorId: '',
        jobId: '',
        eventType: '',
        gender: '',
        type:'',
      },
      tailors: [],
      dialogs: {
        directBulkPrint: {
          isOpen: false,
          loader: false,
          values: ''
        },
        bulkPrint: {
          isOpen: false,
          loader: false,
          values: ''
        },
        bulkOut: {
          isOpen: false,
          loader: false,
          tableHeaders: [
            { text: 'JOB', align: 'start', sortable: false, value: 'name' },
            { text: 'OK', align: 'start', sortable: false, value: 'ok' },
            { text: 'MESSAGE', align: 'start', sortable: false, value: 'reason' },
            { text: 'REMOVE', align: 'start', sortable: false, value: 'remove' },
            
          ],
          tableItems: [],
          values: ''
        },
        bulkIn: {
          isOpen: false,
          loader: false,
          tableHeaders: [
            { text: 'JOB', align: 'start', sortable: false, value: 'name' },
            { text: 'OK', align: 'start', sortable: false, value: 'ok' },
            { text: 'MESSAGE', align: 'start', sortable: false, value: 'reason' },
            { text: 'REMOVE', align: 'start', sortable: false, value: 'remove' },
          ],
          tableItems: [],
          values: ''
        },
        bulkCustomer: {
          isOpen: false,
          loader: false,
          tableHeaders: [
            { text: 'JOB', align: 'start', sortable: false, value: 'name' },
            { text: 'OK', align: 'start', sortable: false, value: 'ok' },
            { text: 'MESSAGE', align: 'start', sortable: false, value: 'reason' },
            { text: 'REMOVE', align: 'start', sortable: false, value: 'remove' },
          ],
          tableItems: [],
          values: '',
        },
      },
      createJobDialog: false,
      appointmentData: {
        id: null
      },
      validCreate: false,
      validCreateLink: false,
      createJobLoading: false,
      formData: {Item: {item: null}, gender: 0, type: 0, metadata: {}},
      customers: [],
      rules: {
        required: [v => !!v || 'This field is required.'],
      },
      jobTypes: [
        {name: "None",id: 0},
        {name: "Formal 👗",id: 1},
        {name: "Bridal 💍",id: 2}
      ],
      items: [],
      loadingItems: false,
      pinners: [],      
      createCustomerDialog: false,
      newCustomer: {address: {}},
      customerLoading: false,
      customerUsage: "create",
      validCreateCustomer: false,
      existingData: null,
      assets: [],
      createAssetDialog: false,
      newAsset: {},
      assetLoading: false,
      assetUsage: "create",
      validCreateAsset: false,
      alterationsLoading: false,
      formDataAlterations: [],
      validCreateEvent: false,
      createEventDialog: false,
      newEvent: {},
      eventLoading: false,
      eventUsage: "create",

      viewStart: '',
      viewEnd: '',
    }
  },
  async mounted(){
    try {
      await this.getAllData()
    } catch (error) {
      console.log(error)
    } finally {
      this.loader = false;
    }
  },
  methods: {
    ...mapMutations([
      'lockGlobalQueryBc',
      'unlockGlobalQueryBc',
      'setScanBusData',
      'setScanBusType',
      'resetScanBus',
    ]),
    async getAllData(){
      try {
        let res;

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        res = await axios.get(`${this.getEndpoint}/api/users`)
        if(res.data.error) throw res.data.error;
        this.users = res.data;

        this.pinners = this.users.filter(x => {
          return x.UserType?.name==="Pinner" // the lack of a ? caused a bug on 13/04/23. Further investigation needed
        });

        res = await axios.get(`${this.getEndpoint}/api/assets`)
        if(res.data.error) throw res.data.error;
        this.assets = res.data.data;

        res = await axios.get(`${this.getEndpoint}/api/alterationTypes`)
        if(res.data.error) throw res.data.error;
        this.alterationTypes = res.data.data;

        res = await axios.get(`${this.getEndpoint}/api/tailors/excludeHidden`)
        if(res.data.error) throw res.data.error;
        this.tailors = res.data.data;

        this.tomorrowJobs = this.jobs.filter(x=>(moment(x.dateToHand).isBetween(moment(), moment().add(1,'days'))))
        this.filtered = false
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },

    showCreateEventDialog(usage="create"){
      this.createEventDialog = true;
      this.eventUsage = usage;
    },
    closeCreateEvent(){
      this.eventUsage = "create";
      this.createEventDialog = false;
      this.newEvent = {};
      this.eventLoading = false;
    },
    async createEvent(usage="create"){
      try{
        this.eventLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/events`, this.newEvent)
        if(res.data.error) throw res.data.error;

        if(usage==="create"){
          this.formData.eventId = res.data.data.id;
        }
        else if(usage==="update"){
          this.selectedRow.eventId = res.data.data.id;
        }
        else{
          throw "Invalid event usage."
        }

        this.snack(`Event Created 🎉`, "success");

        res = await axios.get(`${this.getEndpoint}/api/events`)
        if(res.data.error) throw res.data.error;
        this.events = res.data.data;

        this.closeCreateEvent();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.eventLoading = false;
      }
    },

    async loadAlterations(create=false, linked=false){
      try{
        this.alterationsLoading = true;

        if(!create && !this.selectedRow){
          return;
        }

        if(create && this.formData.alterationType===null){
          this.formDataAlterations = [];
          this.formData.itemAlterations = [];
          return;
        }
        else if(!create && this.selectedRow.alterationType===null){
          this.alterations = [];
          this.selectedRow.itemAlterations = [];
          return;
        }

        if(create){
          let res = await axios.get(`${this.getEndpoint}/api/alterations/byType/${this.formData.alterationType}`)
          if(res.data.error) throw res.data.error;
          this.formDataAlterations = res.data.data;
          this.formData.itemAlterations = [];
          this.calculateCustomerCostForNewUnlinkedJob()
          this.$forceUpdate()
        }
        else if(linked){
          this.linkJobDialog.jobData.itemAlterations = [];
          let res = await axios.get(`${this.getEndpoint}/api/alterations/byType/${this.linkJobDialog.jobData.alterationType}`)
          if(res.data.error) throw res.data.error;

          if(this.linkJobDialog?.jobData?.parentJob){
            let arr = []
            arr = arr.concat(this.linkJobDialog.jobData?.parentJob.itemAlterations.map(x=>x.id))
            arr = arr.concat(this.linkJobDialog.jobData?.parentJob?.childJobs.map(x=>x.itemAlterations.map(y=>y.id)))
            arr = arr.flat(2)
            this.linkJobDialog.jobDataAlterations = res.data.data.filter(x=>!arr.includes(x.id));
          }else if(this.linkJobDialog?.jobData?.childJobs?.length>0){
            let arr = []
            arr = arr.concat(this.selectedRow.itemAlterations.map(x=>x.id))
            arr = arr.concat(this.selectedRow.childJobs.map(x=>x.itemAlterations.map(y=>y.id)))
            arr = arr.flat(2)
            this.linkJobDialog.jobDataAlterations = res.data.data.filter(x=>!arr.includes(x.id));
          }else{
            let arr = []
            arr = arr.concat(this.selectedRow.itemAlterations.map(x=>x.id))
            arr = arr.flat(2)
            this.linkJobDialog.jobDataAlterations = res.data.data.filter(x=>!arr.includes(x.id));
          }
          this.calculateCustomerCostForNewLinkJob()
        }
        else{
          let res = await axios.get(`${this.getEndpoint}/api/alterations/byType/${this.selectedRow.alterationType}`)
          if(res.data.error) throw res.data.error;

          let alterations = res.data.data;

          if(this.selectedRow.parentJob){
            for(let alt of this.selectedRow.parentJob.itemAlterations){
              alterations = alterations.filter(x => x.id!==alt.id);
            }

            for(let cj of this.selectedRow.parentJob.childJobs){
              if(cj.id===this.selectedRow.id) continue;
              for(let alt of cj.itemAlterations){
                alterations = alterations.filter(x => x.id!==alt.id);
              }
            }
          }
          else if(this.selectedRow.childJobs?.length>0){
            for(let cj of this.selectedRow.childJobs){
              for(let alt of cj.itemAlterations){
                alterations = alterations.filter(x => x.id!==alt.id);
              }
            }
          }

          this.alterations = alterations;
          this.calculateCustomerCost()
        }
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.alterationsLoading = false;
      }
    },

    calculateCustomerCostForNewUnlinkedJob(){
      this.formData.totalCost = this.formData.itemAlterations.reduce((acc,x)=>acc+parseFloat(x.price),0)
    },

    openCreateCustomerDialog(usage="create"){
      this.createCustomerDialog = true;
      this.customerUsage = usage;
    },

    closeCreateCustomer(){
      this.customerUsage = "create";
      this.createCustomerDialog = false;
      this.newCustomer = {address: {}};
      this.existingData = null;
      this.customerLoading = false;
    },

    async createCustomer(usage="create"){
      try{
        this.customerLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/customers`, this.newCustomer)
        if(res.data.error) throw res.data.error;

        let newC = res.data.data;

        if(newC.existing){
          this.existingData = newC;
          this.snack("Customer with this phone number already exists.", "error")
          return;
        }

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        if(usage==="create"){
          this.formData.Item.customerId = newC.id;
          await this.updateItems();
        }
        else if(usage==="update"){
          this.selectedRow.Item.Customer.id = newC.id;
          await this.updateSelectedItems();
        }
        else if(usage==="event"){
          this.newEvent.customerId = newC.id;
        }
        else{
          throw "Invalid customer usage."
        }
        this.snack("Customer Created!", "success")
        this.closeCreateCustomer();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.customerLoading = false;
      }
    },
    async confirmCreateCustomer(usage="create"){
      try{
        this.customerLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/customers/force`, this.newCustomer)
        if(res.data.error) throw res.data.error;

        let newC = res.data.data;

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        if(usage==="create"){
          this.formData.Item.customerId = newC;
        }
        else if(usage==="update"){
          this.selectedRow.Item.Customer.id = newC;
        }
        else if(usage==="event"){
          this.newEvent.customerId = newC;
        }
        else{
          throw "Invalid customer usage."
        }
        this.snack("Customer Created!", "success")
        this.closeCreateCustomer();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.customerLoading = false;
      }
    },

    async openCreateJobDialog(){
      this.formData.branchId = this.getLocations.length>0?this.getLocations[0].id:null
      this.formData.dateOut = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.createJobDialog = true
    },
    resetCreateJobDialog(){
      this.formData = {Item: {item: null}, gender: 0, type: 0};
      this.appointmentData = {
        id: null
      }
    },
    closeCreateJobDialog(){
      this.createJobDialog = false
      this.formData = {Item: {item: null}, gender: 0, type: 0, metadata: {}};
    },
    async saveJob(){
      try {
        this.createJobLoading = true
        this.formData.id = null

        if(!this.formData.totalCost) this.formData.totalCost = 0
        if(!this.formData.tailorCost) this.formData.tailorCost = 0

        if(this.formData.gender!==1){
          this.formData.alterationType = null;
          this.formData.itemAlterations = []
        }

        console.log(this.formData)

        let res = await axios.post(`${this.getEndpoint}/api/jobs`, this.formData)
        if(res.data.error) throw res.data.error;
        this.snack(`Job Created 🎉`, "success");

        // await this.loadEvents()

        this.closeCreateJobDialog();

      } catch (error) {

        console.error(error);
        this.snack(error.msg || error, "error");
        this.closeCreateJobDialog();

      } finally {

        this.createJobLoading = false

      }
    },

    showCreateAssetDialog(usage="create"){
      this.createAssetDialog = true;
      this.assetUsage = usage;
    },
    closeCreateAsset(){
      this.assetUsage = "create";
      this.createAssetDialog = false;
      this.newAsset = {};
      this.assetLoading = false;
    },
    async createAsset(usage="create"){
      try{
        this.assetLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/assets`, this.newAsset)
        if(res.data.error) throw res.data.error;

        if(usage==="create"){
          this.formData.Item.item = {
            id: res.data.data.data.id,
            name: res.data.data.data.styleNo,
            type: "asset",
            itemId: null,
            assetId: res.data.data.data.id
          }
        }
        else if(usage==="update"){
          this.selectedRow.customItem = {
            id: res.data.data.data.id,
            name: res.data.data.data.styleNo,
            type: "asset",
            itemId: null,
            assetId: res.data.data.data.id
          }
        }
        else{
          throw "Invalid item usage."
        }

        if(res.data.data.created){
          this.snack(`Asset Created 🎉`, "success");

          res = await axios.get(`${this.getEndpoint}/api/assets`)
          if(res.data.error) throw res.data.error;
          this.assets = res.data.data;

          if(usage==="create"){
            await this.updateItems();
          }
          else if(usage==="update"){
            await this.updateSelectedItems();
          }
        }
        else{
          this.snack(`Asset already exists. Adding to form...`);
        }

        this.closeCreateAsset();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.assetLoading = false;
      }
    },

    async createdCustomerChanged(){
      this.formData.Item.item = null;
      await this.updateItems();
    },
    async updateItems(){
      try{
        this.loadingItems = true;

        let initItems = [];

        if(this.formData.Item.customerId){
          let res = await axios.get(`${this.getEndpoint}/api/items/byCustomer/${this.formData.Item.customerId}`)
          if(res.data.error) throw res.data.error;

          let customerItems = res.data.data;

          initItems.push({disabled:true, name: "-----Customer Items-----"})
          if(customerItems.length===0){
            initItems.push({disabled:true, name: "None"})
          }
          else{
            for(let item of customerItems){
              let name = '';
              name+=item.Asset.styleNo;
              if(item.colour && item.colour.length>0){
                name+=" ("+item.colour+")"
              }

              let obj = {
                name: name,
                id: item.id,
                type: "item"
              };
              initItems.push(obj);
            }
          }
        }
        else{
          this.formData.Item.item = null;
        }

        initItems.push({disabled:true, name: "-----Default Items-----"})
        if(this.assets.length===0){
          initItems.push({disabled:true, name: "None"})
        }
        else{
          for(let asset of this.assets){
            let obj = {
              name: asset.styleNo,
              id: asset.id,
              type: "asset"
            };
            initItems.push(obj);
          }
        }

        this.items = initItems;
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.loadingItems = false;
      }
    },
    async loadEvents(start, end){
      try{
        this.calenderLoader = true;

        this.eventsToDisplay = [];
        this.events = [];

        let res = await axios.get(`${this.getEndpoint}/api/jobs/search?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`);
        if(res.data.error) throw res.data.error;

        this.jobs = res.data.data;
        this.jobs.forEach(job=>{
          /*
            for each job, there could be 3 events associated with it:
              date out
              date in
              date handed off
          */
          if(job.dateIn){
            job.dateIn = this.parseISODate(job.dateIn)
            this.events.push({
              name: (`[${this.lookupLocationIcon(job.branchId)}]`)+(job.parentId?"🔗":"")+((job.childJobs&&job.childJobs.length)>0?'⭐':'')+(job.receivedAt?'✅':'')+(this.parseJobType(job.type, true))+"#"+job.id+" ["+(job.Tailor?.metadata.shortName||'')+"] "+job.Item.Customer.firstName+" "+job.Item.Customer.lastName,
              job: job,
              start: job.dateIn,
              end: job.dateIn,
              color: "blue",
              timed: false
            })
          }
          if(job.dateOut){
            job.dateOut = this.parseISODate(job.dateOut)
            this.events.push({
              name: (`[${this.lookupLocationIcon(job.branchId)}]`)+(job.parentId?"🔗":"")+((job.childJobs&&job.childJobs.length)>0?'⭐':'')+(job.sentAt?'✅':'')+(this.parseJobType(job.type, true))+"#"+job.id+" ["+(job.Tailor?.metadata.shortName||'')+"] "+job.Item.Customer.firstName+" "+job.Item.Customer.lastName,
              job: job,
              start: job.dateOut,
              end: job.dateOut,
              color: "orange",
              timed: false
            })
          }
          if(job.dateToHand){
            job.dateToHand = this.parseISODate(job.dateToHand)
            this.events.push({
              name: (`[${this.lookupLocationIcon(job.branchId)}]`)+(job.parentId?"🔗":"")+((job.childJobs&&job.childJobs.length)>0?'⭐':'')+(job.handedOffAt?'✅':'')+(this.parseJobType(job.type, true))+"#"+job.id+" ["+(job.Tailor?.metadata.shortName||'')+"] "+job.Item.Customer.firstName+" "+job.Item.Customer.lastName,
              job: job,
              start: job.dateToHand,
              end: job.dateToHand,
              color: "red",
              timed: false
            })
          }
        })
        this.eventsToDisplay = this.events  //events to display after all search and filters
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.calenderLoader = false;
      }
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday() {
      this.focus = ''
      this.type = 'day'
    },
    setTodayMonth() {
      this.focus = ''
      this.type = 'month'
    },
    prev () {
      this.$refs.calendar.prev()
      this.clearFilters()
    },
    next () {
      this.$refs.calendar.next()
      this.clearFilters()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    async updateRange (event) {
      let viewStart = this.$refs.calendar.getStartOfWeek(event.start).date;
      let viewEnd = this.$refs.calendar.getEndOfWeek(event.end).date;

      this.viewStart = viewStart;
      this.viewEnd = viewEnd;

      await this.loadEvents(viewStart, viewEnd)
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    momentDateFormat (date) {
      return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
    },
    parseISODate(date){
      return (date?new Date(date).toISOString().substring(0, 10):null);
    },
    parseJobStatus(id){
      if(id===-1) return "Voided"
      else if(id===0) return "New"
      else if(id===1) return "Sent"
      else if(id===2) return "Received"
      else if(id===3) return "Completed"
    },
    parseJobType(id, icon=false){
      if(id===0) return (icon?'':"None")
      else if(id===1) return (icon?'👗':"Formal")
      else if(id===2) return (icon?'💍':"Bridal")
    },
    goToJob(j){
      return this.$router.push({path: `/jobs?selected=${j}`})
    },
    async attemptPrint(e){
      try {
          if(!e.pin&&!e.vsidToken) throw "Error Getting Credentials"
          let res = await axios.post(`${this.getEndpoint}/api/print/jobTicket/${this.selectedEvent.job.id}`, e)
          if(res.data.error) throw res.data.error
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    filterByTailor(){
      console.log(this.eventsToDisplay.filter(x=>!x.job.Tailor))
      this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.job.Tailor&&(x.job.Tailor.id==this.filters.tailorId))
    },
    filterByJob(){
      this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.job.id==this.filters.jobId)
    },
    filterByEventType(){
      this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.color==this.filters.eventType)
    },
    filterByGender(){
      this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.job.gender==this.filters.gender)
    },
    filterByType(){
      if(this.filters.type==0){
        this.eventsToDisplay = this.eventsToDisplay.filter(x=>!x.job.parentId&&(!x.job.childJobs||x.job?.childJobs.length==0))
      }
      if(this.filters.type==1){
        this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.job.childJobs&&x.job.childJobs.length==0)
      }
      if(this.filters.type==2){
        this.eventsToDisplay = this.eventsToDisplay.filter(x=>x.job.parentId)
      }
    },
    clearFilters(){
      this.eventsToDisplay = this.events
      this.filters.tailorId = ""
      this.filters.gender = ""
      this.filters.eventType = ""
      this.filters.jobId = ""
      this.filters.type = ""
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    openDirectBulkPrintDialog(){
      this.dialogs.directBulkPrint.isOpen = true
      this.dialogs.directBulkPrint.loader = false
    },
    closeDirectBulkPrintDialog(){
      this.dialogs.directBulkPrint.isOpen = false
      this.dialogs.directBulkPrint.loader = false
      this.dialogs.directBulkPrint.values = ''
    },
    openBulkPrintDialog(){
      this.dialogs.bulkPrint.isOpen = true
      this.dialogs.bulkPrint.loader = false
    },
    closeBulkPrintDialog(){
      this.dialogs.bulkPrint.isOpen = false
      this.dialogs.bulkPrint.loader = false
      this.dialogs.bulkPrint.values = ''
    },
    openBulkOutDialog(){
      this.dialogs.bulkOut.isOpen = true
      this.dialogs.bulkOut.loader = false
      this.resetScanBus()
      this.setScanBusType('out')
      this.setScanBusData([])
    },
    closeBulkOutDialog(){
      this.dialogs.bulkOut.isOpen = false
      this.dialogs.bulkOut.loader = false
      this.setScanBusType('job')
      this.setScanBusData([])
    },
    async handleDirectBulkPrint(){
      try {
        let res = await axios.post(`${this.getEndpoint}/api/print/directJobTicketBulk`, {jobs: this.dialogs.directBulkPrint.values})
        let printWindow = open("","Printing")
        printWindow.document.write(res.data.data.job.htmlToPrint)
        printWindow.setTimeout(()=>{
          printWindow.print()
        },300)
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
        this.closeDirectBulkPrintDialog()
      }
    },
    async handleBulkPrint(e){
      try {
        e.jobs = this.dialogs.bulkPrint.values
        let res = await axios.post(`${this.getEndpoint}/api/print/jobTicketBulk`, e)
        if(res.data.success){
          this.snack("Bulk Operation Successful")
          this.closeBulkPrintDialog()
        }
        else throw res.data.error
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
        this.closeBulkPrintDialog()
      }
    },
    async handleBulkOut(e){
      try {
        let toSend = this.scanBus.data
        toSend.forEach(x=>x.job = x.job.id)
        e.jobs = toSend
        let res = await axios.put(`${this.getEndpoint}/api/jobs/sendOffBulk/`, e)
        if(res.data.success){
          this.snack("Bulk Operation Successful")
          this.closeBulkOutDialog()
        }
        else throw res.data.error
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
        this.closeBulkOutDialog()
      }
    },
    async handleBulkIn(e){
      try {
        let toSend = this.scanBus.data
        toSend.forEach(x=>x.job = x.job.id)
        e.jobs = toSend
        let res = await axios.put(`${this.getEndpoint}/api/jobs/receiveInBulk/`, e)
        if(res.data.success){
          this.snack("Bulk Operation Successful")
          this.closeBulkOutDialog()
        }
        else throw res.data.error
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
        this.closeBulkOutDialog()
      }
    },
    async handleBulkCustomer(e){
      try {
        let toSend = this.scanBus.data
        toSend.forEach(x=>x.job = x.job.id)
        e.jobs = toSend
        let res = await axios.put(`${this.getEndpoint}/api/jobs/handOffBulk/`, e)
        if(res.data.success){
          this.snack("Bulk Operation Successful", "success")
          this.closeBulkCustomerDialog()
        }
        else throw res.data.error
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
        this.closeBulkCustomerDialog()
      }
    },
    openBulkInDialog(){
      this.dialogs.bulkIn.isOpen = true
      this.dialogs.bulkIn.loader = false
      this.setScanBusType('in')
      this.setScanBusData([])
    },
    closeBulkInDialog(){
      this.dialogs.bulkIn.isOpen = false
      this.dialogs.bulkIn.loader = false
      this.setScanBusType('job')
      this.setScanBusData([])
    },
    openBulkCustomerDialog(){
      this.dialogs.bulkCustomer.isOpen = true
      this.dialogs.bulkCustomer.loader = false
      this.setScanBusType('customer')
      this.setScanBusData([])
    },
    closeBulkCustomerDialog(){
      this.dialogs.bulkCustomer.isOpen = false
      this.dialogs.bulkCustomer.loader = false
      this.setScanBusType('job')
      this.setScanBusData([])
    },
    removeJob(id){
      let temp = this.scanBus.data
      this.setScanBusData(temp.filter(x=>x.job.id != id))
    }
  }
}
</script>
